import { Information } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/components/HrCalculationsInformation';

export const SCENARIO = 'scenario';
export const RECURRENT = 'recurrent';
export const NON_RECURRENT = 'non_recurrent';
export const PAY_COMPONENTS = 'pay_components';
export const RESUME = 'resume';
export const RESULT = 'result';

export const HISTORIC_AMOUNT = 'historicAmount';
export const SIMULATED_AMOUNT = 'simulatedAmount';
export const PAY_COMPONENT = 'payComponent';

// Agent hypotheses fields
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';

// PayComponent hypotheses fields
export const ENVELOPE_PAY_COMPONENT_HYPOTHESIS =
    'envelopePayComponentHypothesis';
// Manty status hypotheses fields
export const ENVELOPE_MANTY_STATUS_HYPOTHESIS = 'envelopeMantyStatusHypothesis';

export const CALCULATION_INFORMATION: Record<string, Information[]> = {
    scenario: [
        { title: 'echelonRaise.title', detail: 'echelonRaise.detail' },
        { title: 'valuePointRaise.title', detail: 'valuePointRaise.detail' },
        { title: 'CNRACLRaise.title', detail: 'CNRACLRaise.detail' },
        { title: 'smicRaise.title', detail: 'smicRaise.detail' },
        {
            title: 'calculationsOrderApplication.title',
            detail: 'calculationsOrderApplication.detail',
        },
    ],
    recurrentAgent: [
        {
            title: 'recurrentSalaryInit.title',
            detail: 'recurrentSalaryInit.detail',
        },
        {
            title: 'agentArrivalAndDeparture.title',
            detail: 'agentArrivalAndDeparture.detail',
            calculation: 'agentArrivalAndDeparture.formula',
        },
        { title: 'ponctualPrimes.title', detail: 'ponctualPrimes.detail' },
        {
            title: 'calculationInfo.title',
            detail: 'calculationInfo.recurrentDetail',
        },
    ],
    nonRecurrentAgent: [
        {
            title: 'nonRecurrentSalaryInit.title',
            detail: 'nonRecurrentSalaryInit.detail',
        },
        {
            title: 'agentArrivalAndDeparture.title',
            detail: 'agentArrivalAndDeparture.detail',
            calculation: 'agentArrivalAndDeparture.formula',
        },
        {
            title: 'calculationInfo.title',
            detail: 'calculationInfo.nonRecurrentDetail',
        },
    ],
    payComponents: [
        {
            detail: 'payComponentsCalculations.detail',
            calculation: 'payComponentsCalculations.formula',
        },
    ],
};
